// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-html-element[data-v-5f0f0f34] {
  width: 100%;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/SharedWeb/scripts/dynamic-component-editor/standard-elements/custom-html-element/CustomHtmlElementProduction.vue","webpack://./CustomHtmlElementProduction.vue"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,YAAA;ACDF","sourcesContent":["@import \"@/styles/breakpoint-mixin.scss\";\n\n.custom-html-element {\n  width: 100%;\n  height: 100%;\n}\n",".custom-html-element {\n  width: 100%;\n  height: 100%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
